<template>
  <div class="accepted_modal">
    <div class="accepted_modal-title">
      {{ `Год: ${item.transName}` }}
    </div>
    <div 
      class="accepted_modal-block"
      v-if="isShow"
    >
      <GraphicCustomPie
        :data="data"
        id="modal"
      />
    </div>  
  </div>
</template>
<script>

import GraphicCustomPie from '@/components/law/GraphicCustomPie.vue'

export default {
  name: 'AcceptedRejectedNormsModal',
  components: {
    GraphicCustomPie
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  watch: {
    item: {
      handler() {
        this.isShow = false
        this.isShow = true
      }
    }
  },

  data () {
    return {
      isShow: true
    }
  },

  computed: {
    data () {
      return [
        {
          id: 1,
          value: this.item.normsWithByLawsInYear,
          transName: 'Кол-во норм, по которым приняты ПА'
        },
        {
          id: 2,
          value: this.item.normsWithoutByLawsInYear,
          transName: 'Кол-во норм, по которым не принято ПА'
        },
        {
          id: 3,
          value: this.item.percentage,
          transName: 'Процентное соотношение'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .accepted_modal {
    width: 100%;

    &-title {
      font-size: 20px;
      font-weight: 400;
      text-align: center;
    }
  
    &-block {
      padding: 40px;
      background-color: #fff;
      z-index: 1004;
      position: relative;
    }
  }
</style>